import { render, staticRenderFns } from "./UploadImageButton.vue?vue&type=template&id=2ca73e0a"
import script from "./UploadImageButton.vue?vue&type=script&lang=ts"
export * from "./UploadImageButton.vue?vue&type=script&lang=ts"
import style0 from "./UploadImageButton.vue?vue&type=style&index=0&id=2ca73e0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports